import getStore from '../store/appHostSearchStore';

export default () => getStore().isSearchEnabled;
